import stylesheet from './ImageCarouselItem.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";

class NXTImageCarouselItem extends CustomComponent {
    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    render() {
        const itemContainer = document.createElement('div');
        itemContainer.classList.add('image-carousel-item')
        itemContainer.innerHTML = `
            <div class="item-media">
                <slot name="image"></slot>
            </div>
            <div class="item-content">
                <div class="overline"><slot name="overline"></slot></div>
                <div class="headline"><slot name="headline"></slot></div>
                <div class="content"><slot></slot></div>
                <div class="pictogram"><slot name="pictogram"></slot></div>
                <div class="pagination"><slot name="pagination"></slot></div>
            </div>
        `;
        this.setHasSlottedToParent(itemContainer);
        this.watchPaginationSlot(itemContainer);
        const image = this.querySelector('nxt-image');
        if (image) {
            image.setAttribute('aspect-ratio', '4 / 3');
            image.setAttribute('aspect-ratio-md', '3 / 4');
            image.setAttribute('aspect-ratio-lg', '4 / 3');
        }
        return itemContainer;
    }

    private watchPaginationSlot(itemContainer: HTMLElement) {
        const slot = itemContainer.querySelector<HTMLSlotElement>('slot[name="pagination"]');
        const wrapper = slot.parentElement;
        const sync = () => {
            const filled = slot.assignedElements().length > 0;
            wrapper.classList.toggle('has-slotted', filled);
            wrapper.classList.toggle('has-slotted-pagination', filled);
        };
        slot.addEventListener('slotchange', sync);
        sync();
    }

}

customElements.define('nxt-image-carousel-item', NXTImageCarouselItem);
